var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9797 2.4038L19.9808 6.3418C20.6108 6.6968 21.0008 7.3648 21.0008 8.0848V8.2298C21.0008 11.0168 20.2257 13.6958 18.8387 16.0108L17.3737 14.5438C18.4187 12.6388 19.0008 10.4748 19.0008 8.2298V8.0848L12.0007 4.1468L8.78475 5.9558L7.31575 4.4878L11.0198 2.4038C11.6258 2.0648 12.3767 2.0638 12.9797 2.4038ZM4.70725 3.293C4.31625 2.902 3.68425 2.902 3.29325 3.293C2.90225 3.684 2.90225 4.316 3.29325 4.707L19.2932 20.707C19.4882 20.902 19.7442 21 20.0002 21C20.2563 21 20.5123 20.902 20.7073 20.707C21.0983 20.316 21.0983 19.684 20.7073 19.293L4.70725 3.293ZM12.302 19.6836L12 19.8536L11.698 19.6836C7.56705 17.3586 5.00005 12.9696 5.00005 8.2296V8.0846L5.16405 7.9926L3.73205 6.5596C3.28105 6.9356 3.00005 7.4866 3.00005 8.0846V8.2296C3.00005 13.6916 5.95705 18.7476 10.7181 21.4256L11.021 21.5966C11.323 21.7666 11.661 21.8506 12 21.8506C12.3391 21.8506 12.6781 21.7656 12.981 21.5956L13.282 21.4256C14.405 20.7946 15.4221 20.0276 16.3291 19.1576L14.915 17.7436C14.1361 18.4866 13.2631 19.1426 12.302 19.6836Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldOff);
export default __webpack_public_path__ + "static/media/ShieldOff.e3d0ca8a15fb59bf4d9c616e084063ba.svg";
export { ForwardRef as ReactComponent };